// Mock de desenvolvimento da Promoção Nacional (REV-1872) — inerte sem a flag.
// Ligar no console do DevTools:  sessionStorage.setItem('NATIONAL_PROMOTION_MOCK', '1')
// Desligar:                      sessionStorage.removeItem('NATIONAL_PROMOTION_MOCK')
// Fixtures no shape CRU do back (NATIONAL_PROMOTION_API.md): stores/products como
// string JSON e recurrenceDays como "1,2,..." — exercitam o normalizeNationalCampaign.

export const isNationalPromotionMockEnabled = () => {
  try {
    return sessionStorage.getItem('NATIONAL_PROMOTION_MOCK') === '1'
  } catch (error) {
    return false
  }
}

const MOCK_STORES_JSON = JSON.stringify([
  { document: '45631645000160', FantasyName: 'RESTAURANTE CHAPADAO LTDA' },
  { document: '48561869000131', FantasyName: 'Posto De Combustiveis Anapolino Ltda' },
  { document: '71549032000199', FantasyName: 'Auto Posto Tulio Ltda' },
  { document: '33333333000100', FantasyName: 'Auto Posto Boa Vista Ltda' }
])

const MOCK_PRODUCTS_JSON = JSON.stringify([
  { productId: 1001, description: 'Gasolina' },
  { productId: 1002, description: 'Diesel' },
  { productId: 1003, description: 'Etanol' }
])

export const MOCK_LIST_RESPONSE = {
  count: 3,
  campaigns: [
    {
      uuid: '130922de-c42c-402f-a0a4-dcf152be5c2e',
      objective: 'Promoção Nacional Ipiranga - Aumentar volume de vendas no 4º trimestre',
      externalId: 1286,
      status: 'ACTIVE',
      startDate: '2026-08-01T00:00:00',
      endDate: '2026-09-30T23:59:59',
      stores: MOCK_STORES_JSON,
      discountType: 'VALOR',
      discountBy: 'TRANSACTION',
      discountValue: 8.0,
      maximumDiscountValue: 20.0,
      minimumFuelPurchaseValue: null,
      products: MOCK_PRODUCTS_JSON,
      usageLimit: 'POR_CNPJ',
      isBudgetUnlimited: true,
      budgetValue: null,
      couponsQuantity: 500,
      isNationalPromotion: true,
      minimumFuelLiters: 20,
      campaignType: 'NATIONAL',
      userEmail: 'promocoes@ipiranga.com.br',
      recurrenceDays: '1,2,3,4,5,6,7',
      history: [
        { status: 'DRAFT', date: '2026-07-30T10:00:00', userEmail: 'analista@ipiranga.com.br' },
        { status: 'ACTIVE', date: '2026-08-01T08:00:00', userEmail: 'aprovador@ipiranga.com.br' }
      ],
      exclusiveList: null,
      createdAt: '2026-07-30T10:00:00',
      updatedAt: '2026-08-31T20:22:42'
    },
    {
      uuid: '2b1f4a7c-9d3e-48f1-b5a6-0c8e7d6f5a4b',
      objective: 'Promoção Nacional Ipiranga - Desconto por litro em combustíveis aditivados',
      externalId: 1174,
      status: 'FINISHED',
      startDate: '2026-05-01T00:00:00',
      endDate: '2026-06-30T23:59:59',
      stores: MOCK_STORES_JSON,
      discountType: 'POR_LITRO',
      discountBy: 'minimumFuelLiters',
      discountValue: 0.5,
      maximumDiscountValue: 15.0,
      minimumFuelPurchaseValue: null,
      products: MOCK_PRODUCTS_JSON,
      usageLimit: 'POR_CUPOM',
      isBudgetUnlimited: false,
      budgetValue: 50000.0,
      couponsQuantity: null,
      isNationalPromotion: true,
      minimumFuelLiters: 15,
      campaignType: 'NATIONAL',
      userEmail: 'promocoes@ipiranga.com.br',
      recurrenceDays: '2,3,4',
      history: [
        { status: 'ACTIVE', date: '2026-05-01T08:00:00', userEmail: 'aprovador@ipiranga.com.br' },
        { status: 'FINISHED', date: '2026-07-01T00:00:00', userEmail: 'aprovador@ipiranga.com.br' }
      ],
      exclusiveList: null,
      createdAt: '2026-04-20T14:12:00',
      updatedAt: '2026-07-01T00:00:00'
    },
    {
      uuid: '7e6d5c4b-3a2f-41e0-9d8c-b7a6f5e4d3c2',
      objective: 'Promoção Nacional Ipiranga - Campanha de fidelização KMV',
      externalId: 1099,
      status: 'INACTIVE',
      startDate: '2026-10-01T00:00:00',
      endDate: '2026-12-31T23:59:59',
      stores: MOCK_STORES_JSON,
      discountType: 'PERCENTUAL',
      discountBy: 'TRANSACTION',
      discountValue: 5,
      maximumDiscountValue: 25.0,
      minimumFuelPurchaseValue: 100.0,
      products: MOCK_PRODUCTS_JSON,
      usageLimit: 'POR_CNPJ',
      isBudgetUnlimited: true,
      budgetValue: null,
      couponsQuantity: null,
      isNationalPromotion: true,
      minimumFuelLiters: null,
      campaignType: 'NATIONAL',
      userEmail: 'promocoes@ipiranga.com.br',
      recurrenceDays: '',
      history: [
        { status: 'DRAFT', date: '2026-09-01T09:00:00', userEmail: 'analista@ipiranga.com.br' }
      ],
      exclusiveList: null,
      createdAt: '2026-09-01T09:00:00',
      updatedAt: '2026-09-01T09:00:00'
    }
  ],
  summary: {
    description: 'Promoção Nacional Ipiranga - Aumentar volume de vendas no 4º trimestre',
    totalCampaigns: 3,
    participatingStores: 4,
    salesWithDiscount: 176,
    totalSalesPercentage: 0,
    amountPaidByCustomer: 32867.2,
    averageTicket: 186.75,
    discountGranted: 1240.8,
    averageDiscount: 7.05,
    fuels: [
      { percent: 32, type: 'Original Gasolina' },
      { percent: 27, type: 'Original Diesel' },
      { percent: 22, type: 'Ipimax Diesel Aditivado' },
      { percent: 18, type: 'Original Etanol' }
    ]
  }
}

export const MOCK_CONSOLIDATED_RESPONSE = {
  summary: {
    description: 'Promoção Nacional Ipiranga - Aumentar volume de vendas no 4º trimestre',
    participatingStores: 4,
    salesWithDiscount: 176,
    totalSalesPercentage: 0,
    amountPaidByCustomer: 32867.2,
    averageTicket: 186.75,
    discountGranted: 1240.8,
    averageDiscount: 7.05,
    fuels: [
      { percent: 32, type: 'Original Gasolina' },
      { percent: 27, type: 'Original Diesel' },
      { percent: 22, type: 'Ipimax Diesel Aditivado' },
      { percent: 18, type: 'Original Etanol' }
    ]
  },
  stores: [
    {
      document: '45631645000160',
      name: 'RESTAURANTE CHAPADAO LTDA',
      salesWithDiscount: 50,
      amountPaid: 10600.0,
      discountGranted: 400.0,
      fuels: [{ percent: 100, type: 'Original Gasolina' }]
    },
    {
      document: '48561869000131',
      name: 'Posto De Combustiveis Anapolino Ltda',
      salesWithDiscount: 24,
      amountPaid: 2755.2,
      discountGranted: 100.8,
      fuels: [{ percent: 100, type: 'Original Etanol' }]
    },
    {
      document: '71549032000199',
      name: 'Auto Posto Tulio Ltda',
      salesWithDiscount: 32,
      amountPaid: 7360.0,
      discountGranted: 320.0,
      fuels: [{ percent: 100, type: 'Ipimax Diesel Aditivado' }]
    },
    {
      document: '33333333000100',
      name: 'Auto Posto Boa Vista Ltda',
      salesWithDiscount: 70,
      amountPaid: 12152.0,
      discountGranted: 420.0,
      fuels: [
        { percent: 74, type: 'Original Diesel' },
        { percent: 26, type: 'Original Etanol' }
      ]
    }
  ],
  externalId: 1286,
  uuid: '130922de-c42c-402f-a0a4-dcf152be5c2e',
  updatedAt: '2026-08-31T20:22:42'
}

export const MOCK_REFUNDS_RESPONSE = {
  count: 6,
  refunds: [
    {
      storeFantasyName: 'RESTAURANTE CHAPADAO LTDA',
      storeDocument: '45631645000160',
      transactionDate: '28/08/2026',
      expectedTransferDate: '04/09/2026',
      transferDate: '',
      value: 152.4,
      status: 'PENDING',
      statusDescription: 'Pagamento previsto'
    },
    {
      storeFantasyName: 'RESTAURANTE CHAPADAO LTDA',
      storeDocument: '45631645000160',
      transactionDate: '21/08/2026',
      expectedTransferDate: '28/08/2026',
      transferDate: '28/08/2026',
      value: 247.6,
      status: 'COMPLETED',
      statusDescription: 'Pago'
    },
    {
      storeFantasyName: 'Posto De Combustiveis Anapolino Ltda',
      storeDocument: '48561869000131',
      transactionDate: '25/08/2026',
      expectedTransferDate: '01/09/2026',
      transferDate: '',
      value: 100.8,
      status: 'TED_REQUESTED',
      statusDescription: 'Pagamento em processamento'
    },
    {
      storeFantasyName: 'Auto Posto Tulio Ltda',
      storeDocument: '71549032000199',
      transactionDate: '19/08/2026',
      expectedTransferDate: '26/08/2026',
      transferDate: '',
      value: 320.0,
      status: 'SPLIT_ERROR',
      statusDescription: 'Pagamento pendente'
    },
    {
      storeFantasyName: 'Auto Posto Boa Vista Ltda',
      storeDocument: '33333333000100',
      transactionDate: '15/08/2026',
      expectedTransferDate: '22/08/2026',
      transferDate: '',
      value: 210.5,
      status: 'TED_FAILURE',
      statusDescription: 'Pagamento não realizado'
    },
    {
      storeFantasyName: 'Auto Posto Boa Vista Ltda',
      storeDocument: '33333333000100',
      transactionDate: '12/08/2026',
      expectedTransferDate: '19/08/2026',
      transferDate: '19/08/2026',
      value: 209.5,
      status: 'COMPLETED',
      statusDescription: 'Pago'
    }
  ]
}
